import { render, staticRenderFns } from "./GlobalPythonEditor.vue?vue&type=template&id=1bef5c26&scoped=true"
import script from "./GlobalPythonEditor.vue?vue&type=script&lang=js"
export * from "./GlobalPythonEditor.vue?vue&type=script&lang=js"
import style0 from "./GlobalPythonEditor.vue?vue&type=style&index=0&id=1bef5c26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bef5c26",
  null
  
)

export default component.exports